import React from 'react';
import PropTypes from 'prop-types';

import Loader from '../loader';

import './style.scss';

const LoaderButton = ({ children, className, loading, ...rest }) => (
  <button disabled={loading} className={`P-loader-button ${className || ''}`} {...rest}>
    {loading ? <Loader /> : children}
  </button>
);

LoaderButton.propTypes = {
  loading: PropTypes.boolean,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default LoaderButton;